import { Extracted } from 'feed/feed-notifications'

/**
 * New posts and comments since the participant last opened the boardlet.
 *
 * The same map also counts items still to do (knowledge checks, polls,
 * ratings...), which opening the boardlet never clears - only completing
 * them does. Those are left out: a badge that stays after the participant
 * has looked reads as a bug.
 */
export const unreadFeedCount = (feed: Partial<Extracted> | undefined): number =>
	(feed?.POST?.count ?? 0) + (feed?.COMMENT?.count ?? 0)

/** A chat count from `<beelday-chat-notifications>`; anything else is 0. */
export const unreadChatCount = (detail: unknown): number => {
	const count = Number(detail)
	return Number.isFinite(count) && count > 0 ? Math.floor(count) : 0
}
